import React from 'react';
const HeroSeekerLogo = React.memo(() => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16.94 16.94" },
        React.createElement("path", { className: "svg-white", d: "M14.88,2.06a7,7,0,0,0-11,8.59L.5,14.05a1.69,1.69,0,0,0,2.39,2.4L6.3,13a7,7,0,0,0,8.58-1,7,7,0,0,0,0-9.94Zm-1.91,8a4.32,4.32,0,1,1,1.26-3A4.33,4.33,0,0,1,13,10.08Z" })));
});
export default HeroSeekerLogo;
